export class SuperDutyError extends Error {
  constructor(
    public statusCode: number,
    public error: string,
    public code: string,
    public message: string,
    public metadata?: Record<string, unknown>
  ) {
    super(message);
  }
}
